import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum AccountingMigrationsColumn {
    ENTITY = "entity",
    SOURCE = "source",
    START_DATE = "startDate",
    END_DATE = "endDate",
    STATUS = "status",
    ACTIONS = "actions",
}

const EntityColumnSchema = ColumnSchema.extend({
    id: z.literal(AccountingMigrationsColumn.ENTITY),
});

const SourceColumnSchema = ColumnSchema.extend({
    id: z.literal(AccountingMigrationsColumn.SOURCE),
});

const StartDateColumnSchema = ColumnSchema.extend({
    id: z.literal(AccountingMigrationsColumn.START_DATE),
});

const EndDateColumnSchema = ColumnSchema.extend({
    id: z.literal(AccountingMigrationsColumn.END_DATE),
});

const StatusColumnSchema = ColumnSchema.extend({
    id: z.literal(AccountingMigrationsColumn.STATUS),
});

const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(AccountingMigrationsColumn.ACTIONS),
});

export const AccountingMigrationsViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.ACCOUNTING_MIGRATIONS),
    columns: z.array(
        z.discriminatedUnion("id", [
            EntityColumnSchema,
            SourceColumnSchema,
            StartDateColumnSchema,
            EndDateColumnSchema,
            StatusColumnSchema,
            ActionsColumnSchema,
        ]),
    ),
});

export type AccountingMigrationsView = z.infer<
    typeof AccountingMigrationsViewSchema
>;
